/* ============================================================
   Soulskart toast system — tiny, accessible, no deps.
   Usage:  window.ssToast('Added to bag', { type:'ok' })
           window.ssToast('Removed', { action:{ label:'Undo', onClick:fn } })
   Emits/listens: document.dispatchEvent(new CustomEvent('ss:toast',{detail:{...}}))
   ============================================================ */
(() => {
  if (window.ssToast) return;

  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ICONS = {
    ok: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    info: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2"/><path d="M10 9v5M10 6.2v.2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  };
  const CLOSE = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  let host;
  const getHost = () => {
    if (host && document.body.contains(host)) return host;
    host = document.createElement('div');
    host.className = 'ss-toast-host';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'false');
    document.body.appendChild(host);
    return host;
  };

  const dismiss = (el) => {
    if (!el || el.dataset.closing) return;
    el.dataset.closing = '1';
    if (REDUCE) return el.remove();
    el.classList.remove('is-in');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
    setTimeout(() => el.remove(), 500); // safety net
  };

  const toast = (message, opts = {}) => {
    const { type = 'ok', duration = 4000, action = null } = opts;
    const el = document.createElement('div');
    el.className = 'ss-toast ss-toast--' + (type === 'info' ? 'info' : 'ok');

    const ico = document.createElement('span');
    ico.className = 'ss-toast__ico';
    ico.innerHTML = ICONS[type] || ICONS.ok;

    const msg = document.createElement('span');
    msg.className = 'ss-toast__msg';
    msg.textContent = message;

    el.append(ico, msg);

    let timer;
    const clear = () => timer && clearTimeout(timer);

    if (action && typeof action.onClick === 'function') {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-toast__act';
      btn.textContent = action.label || 'Undo';
      btn.addEventListener('click', () => { clear(); action.onClick(); dismiss(el); });
      el.append(btn);
    }

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ss-toast__close';
    close.setAttribute('aria-label', 'Dismiss notification');
    close.innerHTML = CLOSE;
    close.addEventListener('click', () => { clear(); dismiss(el); });
    el.append(close);

    getHost().append(el);
    // force reflow then animate in
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));

    if (duration > 0) {
      timer = setTimeout(() => dismiss(el), duration);
      el.addEventListener('mouseenter', clear);
      el.addEventListener('focusin', clear);
    }
    return el;
  };

  window.ssToast = toast;
  document.addEventListener('ss:toast', (e) => {
    if (e && e.detail && e.detail.message) toast(e.detail.message, e.detail);
  });
})();
